import { apiUrl } from '../content/landingContent.js'

export async function fetchPlans() {
  try {
    const res = await fetch(`${apiUrl}/api/public/plans`)
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}
